import { render } from "./menu-application.vue?vue&type=template&id=68c1a75b&scoped=true"
import script from "./menu-application.vue?vue&type=script&lang=js"
export * from "./menu-application.vue?vue&type=script&lang=js"

import "./menu-application.vue?vue&type=style&index=0&id=68c1a75b&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\Project_LenhDienTu\\CauHinhHoaDonDienTu_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c1a75b"]])

export default __exports__